@if (isLocalAuthBypass) {
  <div class="local-bypass-banner">⚠️ LOCAL AUTH BYPASS — DEV ONLY — NOT FOR PRODUCTION</div>
}
@if (isLoading()) {
  <app-progress-spinner-overlay [displayProgressSpinner]="true"></app-progress-spinner-overlay>
} @else {
  <div class="app-shell">
    <app-header
      class="app-shell__header"
      [user]="user()"
      [patientId]="selectedPatientId()"
      [theme]="theme()"
      [navList]="navList()"
      [isWideScreen]="isWideScreen()"
      [hasDraft]="!!newMessageDraft()"></app-header>
    @if (isWideScreen()) {
      <app-side-nav
        [user]="user()"
        [pageHeaderData]="pageHeaderData()"
        [patientId]="patientId()"
        [sideNavOpen]="isSideNavOpen()"
        [isWideScreen]="isWideScreen()"
        (sideNavOpenChange)="setSideNavOpen($event)"
        (dispatchAction)="dispatchSideNavAction($event)"></app-side-nav>
    } @else {
      <main class="app-shell__main">
        <div class="route-host">
          <router-outlet></router-outlet>
        </div>
      </main>
    }
  </div>
}
